import React from 'react';
import styled from 'styled-components';

// Styled Components
const PillContainer = styled.div<{ $tone: 'danger' | 'warning' | 'success' }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 10px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid;
  
  ${props => {
    switch (props.$tone) {
      case 'danger':
        return `
          background: #fef2f2;
          color: #991b1b;
          border-color: #fecaca;
        `;
      case 'warning':
        return `
          background: #fffbeb;
          color: #92400e;
          border-color: #fed7aa;
        `;
      case 'success':
        return `
          background: #f0fdf4;
          color: #166534;
          border-color: #bbf7d0;
        `;
      default:
        return `
          background: ${props.theme.muted};
          color: ${props.theme.mutedForeground};
          border-color: ${props.theme.border};
        `;
    }
  }}
`;

const PillDot = styled.div<{ $tone: 'danger' | 'warning' | 'success' }>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  
  ${props => {
    switch (props.$tone) {
      case 'danger':
        return 'background: #ef4444;';
      case 'warning':
        return 'background: #f59e0b;';
      case 'success':
        return 'background: #16a34a;';
      default:
        return `background: ${props.theme.mutedForeground};`;
    }
  }}
`;

// Types
interface CapacityPillProps {
  pct: number;
  label: string;
  tone: 'danger' | 'warning' | 'success';
}

// Component
export const CapacityPill: React.FC<CapacityPillProps> = ({ pct, label, tone }) => {
  return (
    <PillContainer $tone={tone}>
      <PillDot $tone={tone} />
      {label}
    </PillContainer>
  );
};
